import { render, staticRenderFns } from "./coupons.vue?vue&type=template&id=50674a99&scoped=true&"
import script from "./coupons.vue?vue&type=script&lang=js&"
export * from "./coupons.vue?vue&type=script&lang=js&"
import style0 from "./coupons.vue?vue&type=style&index=0&id=50674a99&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50674a99",
  null
  
)

export default component.exports